import { Stat } from '@/components/ui/Stat';
import { useVaultStorageStats } from '@/hooks/useAdminVaults';
import { formatBytes, formatNumber } from '@/utils/formatters';
import { FileText, HardDrive, Lock, Archive } from 'lucide-react';

export function VaultStorageStats() {
  const { data: stats } = useVaultStorageStats();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Stat label="Total coffres" value={stats?.vaultCount != null ? formatNumber(stats.vaultCount) : '--'} icon={<Lock className="h-5 w-5" />} />
      <Stat label="Documents" value={stats?.documentCount != null ? formatNumber(stats.documentCount) : '--'} icon={<FileText className="h-5 w-5" />} />
      <Stat label="Stockage utilisé" value={stats?.usedStorage != null ? formatBytes(stats.usedStorage) : '--'} icon={<Archive className="h-5 w-5" />} />
      <Stat label="Stockage total" value={stats?.totalStorage != null ? formatBytes(stats.totalStorage) : '--'} icon={<HardDrive className="h-5 w-5" />} />
    </div>
  );
}
